import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { skipLoading } from '../../core/auth-context';

const apiUrl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private http = inject(HttpClient);
  private cachedImages: any[] = [];
  private processed: any[] = [];

  public noImage: string = './../../../../assets/images/no-image.jpg';

  getImages(ids: string[], _skipLoading: boolean = false): Observable<any[]> {

    const reqIds = ids.filter((o: any) => !this.processed.includes(o));
    const context = new HttpContext().set(skipLoading, _skipLoading);

    if (reqIds.length) {
      return this.http.post(`${apiUrl}/core/getImages`, {
        items: reqIds.map((id: any) => {
          return {
            id: id
          }
        })
      }, { context }).pipe(
        tap((res: any) => {
          this.processed = this.processed.concat(ids);
          this.setCached(res.data.images.map((o: any) => ({ id: o.name, image: `data:image/png;base64,${o.b64}` })));
        }),
        map((res: any) => {

          const db = res.data.images.map((o: any) => ({ id: o.name, image: `data:image/png;base64,${o.b64}` }));
          const cached = this.cachedImages.filter((o: any) => ids.includes(o.id));

          return [...db, ...cached];
        })
      );
    }

    const cached = this.cachedImages.filter((o: any) => ids.includes(o.id));
    return of(cached);
  }

  setCached(images: any[]) {

    if (!images.length) return;

    const ids = this.cachedImages.map((o: any) => o.id);

    if (ids.length) {
      for (const image of images) {
        if (!ids.includes(image.id)) {
          this.cachedImages.push(image);
        }
      }
    }
    else {
      this.cachedImages = [...images];
    }
  }
}
